import { render, staticRenderFns } from "./FeedbackReports.vue?vue&type=template&id=20301008"
import script from "./FeedbackReports.vue?vue&type=script&lang=js"
export * from "./FeedbackReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports